module.exports = __webpack_public_path__ + "img/shopping-cart-01.527f5b3b.svg";